import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Axios from 'axios';
import { User } from '../../../types/user';
import { setToken } from '../../../util/api';

const { REACT_APP_API_URL } = process.env;

export const fetchUserThunk = createAsyncThunk('user/fetchUser', async () => {
  const token = await localStorage.getItem('accessToken');
  const result = await Axios.get(`${REACT_APP_API_URL}/user/token`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  console.log({ result });
  return result.data as User;
});

// eslint-disable-next-line camelcase
interface LoginResponse { access_token: string, refresh_token: string }

export const loginThunk = createAsyncThunk('user/loginRequest', async (payload: { email: string, password: string }, { dispatch }) => {
  try {
    const { email, password } = payload;
    const response = await Axios.post(`${process.env.REACT_APP_API_URL}/auth/login?type=cms`, {
      username: email,
      password,
    });

    const {
      access_token: accessToken,
      refresh_token: refreshToken,
    } = response.data as LoginResponse;

    setToken({
      accessToken,
      refreshToken,
    });

    console.log({ accessToken });

    await dispatch(fetchUserThunk());
    return accessToken;
  } catch (e) {
    const { response: { data: { message = '' } = {} } = {} } = e;
    if (message) {
      e.message = message;
    }
    throw e;
  }
});

interface UserState {
  isPending: boolean
  isLoggedIn: boolean
  isFetched: boolean
  data: User
  error: any
  accessToken: string
}

const initialState: UserState = {
  isPending: false,
  isLoggedIn: false,
  isFetched: false,
  data: { _id: '' },
  error: null,
  accessToken: '',
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    logout(state) {
      state.data = initialState.data;
      state.isFetched = initialState.isFetched;
      state.isLoggedIn = initialState.isLoggedIn;
      state.isPending = initialState.isPending;
      localStorage.removeItem('accessToken');
      localStorage.clear();
    },
    dismissError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loginThunk.pending, (state) => {
      state.isPending = true;
      state.error = undefined;
    });
    builder.addCase(loginThunk.fulfilled, (state, action) => {
      state.isPending = false;
      state.isLoggedIn = true;
      state.error = undefined;
      state.accessToken = action.payload;
    });
    builder.addCase(loginThunk.rejected, (state, action) => {
      state.error = action;
      state.isPending = false;
      state.isLoggedIn = false;
    });
    builder.addCase(fetchUserThunk.pending, (state) => {
      state.isPending = true;
      state.error = undefined;
    });
    builder.addCase(fetchUserThunk.fulfilled, (state, action) => {
      state.isFetched = true;
      state.data = action.payload;
    });
    builder.addCase(fetchUserThunk.rejected, (state, action) => {
      state.error = action;
      state.isPending = false;
    });
  },
});

const { actions, reducer } = userSlice;

export const { logout, dismissError } = actions;

export default reducer;
